import React, { useEffect, useState } from "react";
import {
  Card,
  List,
  Button,
  Upload,
  Form,
  message,
  Descriptions,
  Space,
} from "antd";
import { API_METHODS, BLANK_VALUE } from "../../constants";
import useApi from "../../hooks/useApi";
import { useNavigate, useParams } from "react-router-dom";
import { UploadOutlined } from "@ant-design/icons";

function UploadImageToTest() {
  const { test_id } = useParams();
  const [form] = Form.useForm();
  const [items, setItems] = useState();
  const [responseData, getRequest] = useApi(
    `/admin/test/${test_id}`,
    null,
    API_METHODS.GET
  );
  const [postResponseData, postRequest] = useApi(
    `/admin/test/upload-image/${test_id}`,
    null,
    API_METHODS.POST,
    true
  );
  const [testData, setTestData] = useState();
  const [messageApi, contextHolder] = message.useMessage();
  const navigate = useNavigate();

  useEffect(() => {
    getRequest();
  }, []);

  useEffect(() => {
    if (postResponseData.data) {
      messageApi.open({
        type: "success",
        content: "Images added to test successfully",
      });
      navigate("/portal/tests");
    }
  }, [postResponseData]);

  useEffect(() => {
    const data = responseData.data !== BLANK_VALUE ? responseData.data : [];
    setTestData(data);
    if (data) {
      let items = [
        {
          key: "1",
          label: "Test Name",
          children: data.test_name,
        },
        {
          key: "2",
          label: "Test Type",
          children: data.test_type,
        },
        {
          key: "3",
          label: "Total Time",
          children: data.total_time,
        },
        {
          key: "4",
          label: "Month",
          children: data.month,
        },
        {
          key: "5",
          label: "Week",
          children: data.week,
        },
        {
          key: "6",
          label: "Description",
          children: data.descriptions,
        },
      ];
      setItems(items);
    }
  }, [responseData]);

  const uploadProps = {
    beforeUpload: (file) => {
      const isImage = file.type === "image/png" || file.type === "image/jpeg";
      if (!isImage) {
        messageApi.open({
          type: "error",
          content: "${file.name} error. Only PNG and JPEG files supported",
        });
      }
      return isImage || Upload.LIST_IGNORE;
    },
  };

  const dummyRequest = ({ file, onSuccess }) => {
    setTimeout(() => {
      onSuccess("ok");
    }, 0);
  };

  const uploadImages = () => {
    form
      .validateFields()
      .then((values) => {
        const formData = new FormData();
        for (const name in values) {
          if (values[name] !== undefined) {
            formData.append(
              name,
              values[name].file.originFileObj,
              values[name].file.name
            );
          }
        }
        formData.append("test_id", test_id);
        postRequest(formData);
      })
      .catch((e) => {});
  };

  return (
    <Space direction="vertical" style={{ width: "100%" }}>
      {contextHolder}
      <Card title="Details">
        <Descriptions bordered items={items} column={4} />
      </Card>
      <Card>
        <Form layout="vertical" form={form}>
          {testData && testData.test_type_id != 3 && (
            <List
              dataSource={testData?.questions}
              renderItem={(item) => (
                <List.Item>
                  <Card
                    title={`${item.question_number}: ${item.question_text}`}
                    style={{ width: "100%" }}
                  >
                    <b>Question Image</b>
                    <Form.Item
                      name={item.question_number}
                      label=""
                      style={{ marginLeft: 25 }}
                    >
                      <Upload
                        {...uploadProps}
                        customRequest={dummyRequest}
                        listType="picture-card"
                        // fileList={fileList}
                        // onChange={handleChange}
                        multiple={false}
                      >
                        {<UploadOutlined />}
                      </Upload>
                    </Form.Item>
                    {item.options.map((option, index) => (
                      <div key={index}>
                        <strong>{option.option_label}</strong>:{" "}
                        {option.option_text}
                        {option.is_correct_option && (
                          <span style={{ color: "green" }}> (Correct)</span>
                        )}
                        <Form.Item
                          name={
                            item.question_number + "-" + option.option_label
                          }
                          label=""
                          style={{ marginLeft: 25 }}
                        >
                          <Upload
                            {...uploadProps}
                            customRequest={dummyRequest}
                            listType="picture-card"
                            // fileList={fileList}
                            // onChange={handleChange}
                            multiple={false}
                          >
                            {<UploadOutlined />}
                          </Upload>
                        </Form.Item>
                      </div>
                    ))}
                  </Card>
                </List.Item>
              )}
            />
          )}
          {testData && testData.test_type_id == 3 && (
            <>
              <p>Mock Test Number -{testData.mock_test_number} </p>
              <List
                dataSource={testData?.sections}
                renderItem={(item) => (
                  <List.Item>
                    <Card title={item.name} style={{ width: "100%" }}>
                      <p>Time Limit -{item.time_limit}</p>
                      <List
                        dataSource={item.questions}
                        renderItem={(inner_item) => (
                          <List.Item>
                            <Card
                              title={`${inner_item.question_number}: ${inner_item.question_text}`}
                              style={{ width: "100%" }}
                            >
                              <b>Question Image</b>
                              <Form.Item
                                name={
                                  item.section_order +
                                  "-" +
                                  inner_item.question_number
                                }
                                label=""
                                style={{ marginLeft: 25 }}
                              >
                                <Upload
                                  {...uploadProps}
                                  customRequest={dummyRequest}
                                  listType="picture-card"
                                  // fileList={fileList}
                                  // onChange={handleChange}
                                  multiple={false}
                                >
                                  {<UploadOutlined />}
                                </Upload>
                              </Form.Item>

                              {inner_item.options.map((option, index) => (
                                <div key={index}>
                                  <strong>{option.option_label}</strong>:{" "}
                                  {option.option_text}
                                  {option.is_correct_option && (
                                    <span style={{ color: "green" }}>
                                      (Correct)
                                    </span>
                                  )}
                                  <Form.Item
                                    name={
                                      item.section_order +
                                      "-" +
                                      inner_item.question_number +
                                      "-" +
                                      option.option_label
                                    }
                                    label=""
                                    style={{ marginLeft: 25 }}
                                  >
                                    <Upload
                                      {...uploadProps}
                                      customRequest={dummyRequest}
                                      listType="picture-card"
                                      // fileList={fileList}
                                      // onChange={handleChange}
                                      multiple={false}
                                    >
                                      {<UploadOutlined />}
                                    </Upload>
                                  </Form.Item>
                                </div>
                              ))}
                            </Card>
                          </List.Item>
                        )}
                      />
                    </Card>
                  </List.Item>
                )}
              />
            </>
          )}
          <Button
            type="primary"
            style={{ float: "right" }}
            onClick={uploadImages}
          >
            Save
          </Button>
        </Form>
      </Card>
    </Space>
  );
}

export default UploadImageToTest;
